import React from "react";
import threeunitFJJ from "../assets/images/zzs_fjj.png";


const FjjDetails = () => {
  return (
    <section className="team-details">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-5">
            <div className="team-details__content">
              <h2 className="team-details__title">智能分拣(Vortex系列)</h2>
              <h3 className="team-details__subtitle" style={{ fontWeight: "bold" }}>产品特点</h3>
              <strong style={{ color: "black" }}>漩涡般高效吸附:  </strong>
              采用先进的蜘蛛手吸附技术，吸力强劲且稳定，能够快速、精准地抓取各类输液袋/瓶，确保高效分拣的同时避免漏抓或损坏。<br /><br />

              <strong style={{ color: "black" }}>动态分拣结合：</strong>
              多关节蜘蛛手设计灵活，可动态调整抓取角度和路径，适应不同规格、形状的输液包装，实现复杂多仓位下的高效分拣。<br/>
              <br/>

              <strong style={{ color: "black" }}>智能精准控制：</strong>
              配备智能识别系统，实时定位输液包装位置，结合动态分拣算法，确保分拣过程精准无误，大幅提升分拣效率与准确率。



              <h3 className="team-details__subtitle">设计理念</h3>
              <p className="team-details__text">
                结构简单、耐用、可靠。设计原理上就将故障发生的可能性降到最低。
                部件选用上遵循“大马拉小车”的原则，保证部件寿命的足够设计冗余，以满足医院这一特殊用户群体的无故障要求。
                模块化设计，独特的动态仓位分布系统。即使单一模块故障，也能完成整个分拣流程。
                所有子系统均要满足软件硬件double-check的原则，以保证系统的稳定可靠杜绝故障的发生。
              </p>


            </div>
          </div>
          <div className="col-lg-6">
            <h2 className="team-details__title" style={{ fontWeight: "bold" }}>运用场景</h2>
            <p className="team-details__text">
              运用条码实时提取技术，结合自动化流水线，将PIVAS成品输液按科室，快速高效的分拣，把人工解放出来。
            </p>
            <br />
            <div className="team-one__single">
              <div className="course-one__image">
                <img src={threeunitFJJ} alt="" />
              </div>

              <div className="team-one__content">
                <h2 className="team-one__name">
                  <a href="/team-details">智能分拣机设备(Vortex系列)</a>
                </h2>
                <p className="team-one__designation">苏州卫捷</p>
              </div>
              <div className="team-one__social">
                <a href="#none">
                  <i className="fab "></i>
                </a>

                {/* <a href="#none">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#none">
                  <i className="fab fa-facebook-square"></i>
                </a>
                <a href="#none">
                  <i className="fab fa-pinterest-p"></i>
                </a>
                <a href="#none">
                  <i className="fab fa-instagram"></i>
                </a> */}
              </div>

            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FjjDetails;
